var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp2StickerRoundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.f{fill:#3c3c46;}.b{opacity:0.15;}.c{fill:#3ca4ef;}.c,.d,.e,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;fill-rule:evenodd;}.c,.d,.e,.g{stroke-width:2px;}.d{fill:#89d9fb;}.e{fill:#ffefe0;}.f{stroke-width:1.2px;opacity:0.2;}.g{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-sticker-round-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75,
    cy: 79.99,
    r: 41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67,115A41,41,0,1,0,26,74,41.08,41.08,0,0,0,67,115Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69,111A41,41,0,1,0,28,70,41.08,41.08,0,0,0,69,111Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65,107A41,41,0,1,0,24,66,41.08,41.08,0,0,0,65,107Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M106,72.59A41,41,0,1,1,54.4,21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M66.85,19a41,41,0,0,1,39,53.57v0L54.25,21l.16-.05A41,41,0,0,1,66.85,19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M94.89,77.22c-22.64,6.42-41-6.73-41-29.37a46.47,46.47,0,0,1,2-13.12v0l51.62,37-.16.1A51.39,51.39,0,0,1,94.89,77.22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M93.43,74.53A41,41,0,0,1,54.4,21v0L106,72.56l-.16.05A41,41,0,0,1,93.43,74.53Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp2StickerRoundIcon);
export default __webpack_public_path__ + "static/media/CP2-sticker-round-icon.68d7adb0d015a3c2ad2a72030a7d0ed3.svg";
export { ForwardRef as ReactComponent };